// Anonyme Nutzungsstatistik. Gesendet wird an /track.php (siehe public/track.php).
// Es wird nur eine zufällige Geräte-ID gespeichert, keine IP-Adresse und keine Namen.
// Auf einem Gerät abschalten: localStorage 'ls_nicht_zaehlen' = '1' (geht über die Statistikseite).

const API = '/track.php';
const ID_KEY = 'ls_geraet_id';
const AUS_KEY = 'ls_nicht_zaehlen';
const NEUER_AUFRUF_NACH = 30 * 60 * 1000;

let letzterAufruf = 0;
let modellHinweis = '';

function zufallsId() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch (err) { }
  return 'x' + Date.now().toString(16) + Math.random().toString(16).slice(2, 14);
}

function geraeteId() {
  try {
    let id = localStorage.getItem(ID_KEY);
    if (!id) {
      id = zufallsId();
      localStorage.setItem(ID_KEY, id);
    }
    return id;
  } catch (err) {
    return null;
  }
}

function aktiv() {
  if (process.env.NODE_ENV !== 'production') return false;
  try {
    return localStorage.getItem(AUS_KEY) !== '1';
  } catch (err) {
    return true;
  }
}

function istPwa() {
  return !!(window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone);
}

function senden(typ, wert) {
  if (!aktiv() || !navigator.onLine) return;
  const id = geraeteId();
  if (!id) return;

  const daten = {
    id,
    typ,
    wert: wert ? String(wert).slice(0, 150) : '',
    modell: modellHinweis,
    breite: window.screen?.width || 0,
    hoehe: window.screen?.height || 0,
    dpr: window.devicePixelRatio || 1,
    touch: navigator.maxTouchPoints || 0,
    pwa: istPwa() ? 1 : 0,
    sprache: navigator.language || ''
  };

  try {
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(daten),
      keepalive: true
    }).catch(() => { });
  } catch (err) { }
}

export function trackEreignis(typ, wert) {
  senden(typ, wert);
}

function trackAufruf() {
  letzterAufruf = Date.now();
  senden('aufruf');
}

// Zählt einen Aufruf beim Start der App und erneut, wenn sie nach mehr als 30 Minuten wieder geöffnet wird.
export async function startTracking() {
  if (!aktiv()) return;

  // Das genaue Gerätemodell liefern nur manche Android-Browser (Client Hints).
  try {
    const werte = await navigator.userAgentData?.getHighEntropyValues?.(['model']);
    modellHinweis = werte?.model || '';
  } catch (err) { }

  trackAufruf();

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && Date.now() - letzterAufruf > NEUER_AUFRUF_NACH) trackAufruf();
  });
}
